module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0011.jpg?v=b1ece498";